export * from "./types.js";
export * from "./copy.js";
export {
  homeBuyingCost,
  fyForDate,
  assertNoCreditHandoff,
  CreditHandoffError,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { HomeBuyingCostRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/**
 * Registry of home-buying-cost composer rulesets by financial year. The ONLY
 * constants this module owns are the indicative misc-cost ranges — every other
 * figure comes from a child module's own dated ruleset. Historical years stay
 * registered so a backdated assessment resolves against the misc ranges in force
 * then (never mutate a shipped file — append a new dated one).
 */
export const HOME_BUYING_COST_RULESETS: Record<string, HomeBuyingCostRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the home-buying-cost composer ruleset for a FY, or throw if unknown. */
export function homeBuyingCostRulesFor(fy: string): HomeBuyingCostRuleSet {
  const rules = HOME_BUYING_COST_RULESETS[fy];
  if (!rules) {
    throw new Error(`no home-buying-cost ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent composer ruleset — the default for live "this year" calcs. */
export const HOME_BUYING_COST_CURRENT_FY = "2025-26";
